import React from 'react';

const SVG = ({ style = {}, fill = '#000', width = 100, className = '', viewBox = '0 0 48 48' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox={viewBox}
    className={`svg-icon ${className || ''}`}
  >
    <defs>
      <ellipse id="a" cx="14.601" cy="14.266" rx="14.601" ry="14.266" />
      <path
        id="c"
        d="M10.632 39.957s3.283-4.556 3.394-11.385c.111-6.83-1.858-8.533-3.394-12.248-1.528-4.12-2.126-6.143-.983-10.375C10.793 1.72 8.81 0 7.015 0s-3.93 1.8-2.89 5.921c1.038 4.122.801 6.283-.727 10.403C1.862 20.039-.107 21.743.005 28.572c.11 6.829 3.393 11.385 3.393 11.385h7.234z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h48v48H0z" />
      <g transform="translate(7 13.951)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#004F7E" xlinkHref="#a" />
        <ellipse cx="11.681" cy="9.986" fill="#37769C" mask="url(#b)" rx="14.601" ry="14.266" />
        <ellipse cx="12.533" cy="10.343" fill="#004F7E" mask="url(#b)" rx="1.825" ry="1.783" />
        <ellipse cx="16.913" cy="6.063" fill="#004F7E" mask="url(#b)" rx="1.825" ry="1.783" />
        <ellipse cx="11.073" cy="4.636" fill="#004F7E" mask="url(#b)" rx="1.825" ry="1.783" />
      </g>
      <g transform="translate(26.468 3)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <use fill="#D5D8DB" xlinkHref="#c" />
        <path
          fill="#EBEBEB"
          d="M11.677 28.572c.093-6.83-1.546-8.533-2.825-12.248-1.272-4.12-1.77-6.143-.818-10.375C8.985 1.72 7.334 0 5.84 0 4.347 0 2.568 1.8 3.433 5.921c.866 4.122.668 6.283-.604 10.403C1.55 20.039-.089 21.743.004 28.572c.092 6.829 2.159 9.114 2.159 9.114s9.499 1.187 9.514-9.114z"
          mask="url(#d)"
        />
        <path
          stroke="#FF2552"
          strokeLinecap="square"
          strokeWidth="3"
          d="M5.11 9.424h4.38M5.11 13.521h4.38"
          mask="url(#d)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
